import { h } from "preact";
import { extractHostName } from "../extractHostName";

export const StoryBaseUrl = ({ story }) => story.url && <span className="info-span"> (<a href={`https://news.ycombinator.com/from?site=${extractHostName(story.url)}`}>{extractHostName(story.url)}</a>)</span>;
